<sc-flex vertical stretchContent fitHeight>

  <sc-dialog-title>
    <sc-dictionary-label dictionaryKey="tmc-yard.common.transport-routing.title"></sc-dictionary-label>
  </sc-dialog-title>

  <app-transport-info-panel [carrier]="transportRouting.carrier" [identifier]="transportRouting.identifier"
    [driver]="transportRouting.name" [scope]="transportRouting.transportScope"></app-transport-info-panel>

  <sc-flex-fitting-content vertical>
    <sc-padding [formGroup]="form">

      <sc-flex>
        <mat-checkbox name="useAsShuttle" formControlName="useAsShuttle" (ngModelChange)="onModelChanged()"
          *ngIf="shuttleTransportsEnabled">
          <sc-dictionary-label
            dictionaryKey="tmc-yard.common.transport-routing.routingPosition.use-as-shuttle"></sc-dictionary-label>
        </mat-checkbox>

        <sc-content-spacer></sc-content-spacer>

        <sc-button (click)="reloadRoute()" iconClass="fa-sync-alt"
          dictionaryKey="tmc-yard.transport-routing.ui.edit-route.reload-positions">
        </sc-button>

        <sc-content-spacer></sc-content-spacer>

        <mat-checkbox name="changeRouteManually" formControlName="changeRouteManually"
          [disabled]="transportRouting.changeRouteManually" (ngModelChange)="onModelChanged()">
          <sc-dictionary-label
            dictionaryKey="tmc-yard.common.transport-routing.routingPosition.change-route-manually"></sc-dictionary-label>
        </mat-checkbox>
      </sc-flex>

      <sc-content-spacer vertical></sc-content-spacer>

      <sc-flex vertical stretchContent [gap]="16" class="form-box">

        <sc-row-container *ngFor="let position of getNonChangeableRoutings()">
          <sc-padding>
            <sc-flex centered>
              <sc-flex-fitting-content>
                <app-routing-position-editor [routingPosition]="position" [disabled]="true" />
              </sc-flex-fitting-content>
            </sc-flex>
          </sc-padding>
        </sc-row-container>

      </sc-flex>

      <sc-content-spacer vertical></sc-content-spacer>

      <sc-flex vertical stretchContent [gap]="16" class="form-box" cdkDropList (cdkDropListDropped)="drop($event)">

        <sc-draggable-row-container class="dragable" cdkDrag [cdkDragDisabled]="!transportRouting.changeRouteManually"
          *ngFor="let position of getChangeableRoutings()">
          <sc-padding>
            <sc-flex centered>
              <sc-flex-fitting-content>
                <app-routing-position-editor [routingPosition]="position" (changed)="positionUpdated(position)" />
              </sc-flex-fitting-content>
              <sc-action-icon iconClass="fa-minus-circle" (click)="removePosition(position)" large></sc-action-icon>
            </sc-flex>
          </sc-padding>
        </sc-draggable-row-container>

      </sc-flex>

      <sc-content-spacer vertical></sc-content-spacer>

      <sc-flex centered>
        <sc-action-icon (click)="addPosition()" iconClass="fa-circle-plus"
          [disabled]="isLoading || !transportRouting.changeRouteManually" large></sc-action-icon>
      </sc-flex>

    </sc-padding>
  </sc-flex-fitting-content>

  <sc-actionbar>
    <sc-content-spacer grow></sc-content-spacer>
    <sc-cancel-button class="cancel-button" (click)="cancel()"></sc-cancel-button>
    <sc-content-spacer></sc-content-spacer>
    <sc-save-button primary (click)="save()" class="confirm-button" [disabled]="isSaveDisabled"></sc-save-button>
  </sc-actionbar>

</sc-flex>
